import script from "./StudentHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentHeader.vue?vue&type=script&setup=true&lang=js"

import "./StudentHeader.vue?vue&type=style&index=0&id=667d9caa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-667d9caa"]])

export default __exports__